import * as React from 'react';

const PendingActionItem24: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect width='26' height='26' rx='13' fill='white' />
		<rect x='0.5' y='0.5' width='25' height='25' rx='12.5' stroke='black' strokeOpacity='0.1' />
		<path
			d='M12.9998 3.24977C18.3847 3.24977 22.7496 7.61488 22.7498 12.9998C22.7498 18.3848 18.3848 22.7498 12.9998 22.7498C7.61486 22.7497 3.24976 18.3847 3.24976 12.9998C3.24988 7.61495 7.61493 3.24989 12.9998 3.24977ZM12.9998 6.24977C12.8009 6.24983 12.6101 6.3289 12.4695 6.4695C12.3289 6.61009 12.2498 6.80094 12.2498 6.99977V12.9998C12.2498 13.4137 12.5859 13.7497 12.9998 13.7498H17.4998C17.6987 13.7498 17.8894 13.6707 18.03 13.53C18.1707 13.3894 18.2498 13.1987 18.2498 12.9998C18.2497 12.8009 18.1706 12.6101 18.03 12.4695C17.8894 12.329 17.6986 12.2498 17.4998 12.2498H13.7498V6.99977C13.7497 6.80094 13.6706 6.61009 13.53 6.4695C13.3894 6.32899 13.1986 6.24977 12.9998 6.24977Z'
			fill='#D97F18'
		/>
	</svg>
);

export default PendingActionItem24;
